export const ParameterRoutes = [
  {
    route: 'delivery',
    label: '::Menu:Settings:Delivery',
    sections: [
      {
        label: '::General',
        items: [
          {
            label: '::Menu:Deliveries:DeliveryRoutesDefinition',
            route: 'delivery-definition',
            icon: 'digi-out-truck',
          },
        ],
        isOpen: true,
      },
    ],
  },
];
